import styled, { css } from 'styled-components';

import colors from '../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 10px 30px 30px;
`;

const DropZoneBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 32px 24px;
  text-align: center;
  cursor: pointer;
  border: 2px dashed ${colors.shades.secondary6};
  border-radius: 12px;
  background: ${colors.shades.secondary10};
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    border-color: ${colors.shades.secondary2};
  }

  ${({ $dragging }) => $dragging && css`
    border-color: ${colors.shades.secondary2};
    background: ${colors.shades.secondary5};
  `}
`;

const DropTitle = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.shades.secondary8};
`;

const DropSubtitle = styled.span`
  font-size: 13px;
  color: ${colors.shades.gamma7};
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.shades.secondary8};
`;

const ItemCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 10px;
  background: ${colors.base.alpha};
`;

const ItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FileName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.shades.secondary8};
  margin-right: auto;
  overflow-wrap: anywhere;
`;

const Meta = styled.span`
  font-size: 13px;
  color: ${colors.shades.gamma7};
`;

const MessageList = styled.ul`
  margin: 4px 0 0;
  padding-left: 20px;
  font-size: 13px;
`;

/*
  Top-aligned, with the button as tall as the small (40px) inputs: centring would line the
  button up with the field plus its helper text ("last deployed here") rather than the field.
*/
const TargetRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;

  & > .MuiAutocomplete-root {
    flex: 1 1 320px;
  }

  & > .MuiTextField-root {
    flex: 0 1 260px;
  }

  & > button {
    height: 40px;
  }
`;

const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const OptionDomain = styled.span`
  font-size: 12px;
  color: ${colors.shades.gamma7};
`;

const Details = styled.pre`
  margin: 0;
  padding: 10px;
  font-size: 12px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: ${colors.base.gamma};
  border-radius: 6px;
`;

// The theme's primary (lime) is too light to read as link text on white.
const SiteLink = styled.a`
  color: ${colors.shades.secondary2};
  font-weight: 500;
  text-decoration: underline;
  overflow-wrap: anywhere;

  &:hover {
    color: ${colors.base.beta};
  }
`;

export {
  Container,
  DropZoneBox,
  DropTitle,
  DropSubtitle,
  SectionHeader,
  SectionTitle,
  ItemCard,
  ItemHeader,
  FileName,
  Meta,
  MessageList,
  TargetRow,
  OptionContent,
  OptionDomain,
  Details,
  SiteLink,
};
